import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { styles } from './styles';

const LoaderButton = ({ children, loading, circleColor = 'primary', ...rest }) => {
	return (
		<Button disabled={loading} {...rest}>
			{children}
			{loading && <CircularProgress color={circleColor} size={24} sx={styles.loader} />}
		</Button>
	);
};

export default LoaderButton;
